import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import {
  ICreateAllocationTemplate,
  IUpdateAllocationTemplate,
} from 'common/src/types/allocationTemplateDto';
import { IAllocationTemplate, IPage } from 'common/src/types/interfaces';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const addAllocationTemplate = async (
  body: ICreateAllocationTemplate,
): Promise<string> =>
  await postRequest(API_BASE_PATHS.ALLOCATION_TEMPLATES, {}, body);

export const getAllocationTemplates = async (
  params: DataQueryParams,
): Promise<IPage<IAllocationTemplate>> =>
  await getRequest(
    API_BASE_PATHS.ALLOCATION_TEMPLATES,
    formatQueryParams(params),
  );

export const updateAllocationTemplate = async (
  id: string,
  body: IUpdateAllocationTemplate,
): Promise<string> =>
  await patchRequest(`${API_BASE_PATHS.ALLOCATION_TEMPLATES}/${id}`, {}, body);

export const deleteAllocationTemplate = async (id: string): Promise<void> =>
  await deleteRequest(`${API_BASE_PATHS.ALLOCATION_TEMPLATES}/${id}`);
